var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartbrokenBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449,218.48c-5.32-28.59-19.6-56.13-35.25-79.91-23.25-35.31-59-68.38-103.82-66.3-25.87,1.19-49.25,13.46-66.71,32.27-16.79,18.09-28.15,38.73-52.09,48.49-24.23,9.87-50.31,15.39-75.52,22.08C50.8,192.29,16.25,274.32,48.2,341.77S155.19,442,207.79,428c47.27-12.53,78.64-51.2,121.51-70.72,21.27-9.67,44.81-11.13,65.34-22.63,23.86-13.36,43.78-35.44,51.95-61.92C452.15,254.69,452.33,236.38,449,218.48Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,218.48c-5.32-28.59-19.6-56.13-35.25-79.91-23.25-35.31-59-68.38-103.82-66.3-25.87,1.19-49.25,13.46-66.71,32.27-16.79,18.09-28.15,38.73-52.09,48.49-24.23,9.87-50.31,15.39-75.52,22.08C50.8,192.29,16.25,274.32,48.2,341.77S155.19,442,207.79,428c47.27-12.53,78.64-51.2,121.51-70.72,21.27-9.67,44.81-11.13,65.34-22.63,23.86-13.36,43.78-35.44,51.95-61.92C452.15,254.69,452.33,236.38,449,218.48Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.78,275s0-4.06-5.68-9.73-9.32-8.92-9.32-8.92-2.84,9.32,2.43,15a99.87,99.87,0,0,0,12.57,10.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,300.27s0-4-5.68-9.73-9.32-8.91-9.32-8.91S82.7,291,88,296.63a99.87,99.87,0,0,0,12.57,10.94Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42,281.86s.43-4,6.67-9.08,10.22-7.88,10.22-7.88,1.83,9.57-4,14.66a99.64,99.64,0,0,1-13.65,9.56Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.47,311.76s.85-4,7.59-8.32,11-6.77,11-6.77.82,9.71-5.52,14.16a100.22,100.22,0,0,1-14.58,8.07Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.34,344.36s0-4.05,5.68-9.73,9.32-8.92,9.32-8.92,2.84,9.33-2.43,15a99.44,99.44,0,0,1-12.57,11Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.25,352.32s.57-4-4.24-10.44-8-10.15-8-10.15-4.14,8.82.27,15.19a99.24,99.24,0,0,0,10.89,12.62Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.65,375.9s0-4,5.67-9.73,9.33-8.92,9.33-8.92,2.84,9.33-2.43,15A99.44,99.44,0,0,1,94.65,383.2Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,397.28s-1-3.92,3-10.85,6.77-11,6.77-11,5.1,8.31,1.44,15.13a99.43,99.43,0,0,1-9.38,13.77Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,273.92a115,115,0,0,1-1.55,12.58c-2.25,11.6-7.86,19.07-10.1,29.54s4.2,24,2.47,37.41-7,20.93-5.46,29.9,9.57,33.79,9.57,33.79",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.36,
    y1: 284.55,
    x2: 114.48,
    y2: 279.86,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.65,
    y1: 279.15,
    x2: 106.09,
    y2: 274.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,315.56s5.12-3.84,10.38-7.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,307.57s-4.27-8.36-9.1-13.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54,350.13a63.36,63.36,0,0,1,10.95-14.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.55,355.82A72.51,72.51,0,0,0,94,345.29c-3-4.41-3.42-5-3.42-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.65,383.35A67.78,67.78,0,0,1,99.26,374a59.75,59.75,0,0,1,6-7.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.29,404.34a17.4,17.4,0,0,1,1.53-9c2.13-4.12,4.55-9.53,5.55-11.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.46,329.12S62,326.57,65,322.4s4.88-6.61,4.88-6.61,2.79,5.54.1,9.67a62.93,62.93,0,0,1-6.69,8.23Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.37,344.1s-.44-2.54,2.51-6.72,4.88-6.6,4.88-6.6,2.79,5.53.1,9.67a63.39,63.39,0,0,1-6.69,8.22Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.43,333.41s-.7-2.48-5.17-5S51,324.6,51,324.6s-.11,6.21,4.1,8.76a63.23,63.23,0,0,0,9.6,4.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.92,351.08s-1-2.4-5.66-4.4-7.63-3.05-7.63-3.05.54,6.18,5,8.28a63.52,63.52,0,0,0,10,3.48Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,371.72s-.45-2.54-4.62-5.48-6.82-4.58-6.82-4.58-.76,6.15,3.16,9.14a63.09,63.09,0,0,0,9.07,5.5Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.21,376.7s-.8-2.45,1.52-7,3.89-7.23,3.89-7.23,3.55,5.08,1.48,9.55a63.45,63.45,0,0,1-5.46,9.1Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33,397.21s.3-2.56,4.3-5.74,6.54-5,6.54-5,1.12,6.1-2.63,9.3a62.88,62.88,0,0,1-8.74,6Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.28,390.88s-.44-2.54-4.62-5.48-6.81-4.58-6.81-4.58S70.08,387,74,390a63.09,63.09,0,0,0,9.07,5.5Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.22,404.7s.22-2.57-3.07-6.47-5.44-6.16-5.44-6.16-2.3,5.76.74,9.64a63.26,63.26,0,0,0,7.38,7.62Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,328.52a72.77,72.77,0,0,0,2.35,7.72c2.66,7,7,11.11,9.53,17.43s0,15.48,2.51,23.73,6.64,12.37,6.68,18.16S81,417,81,417",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.76,
    y1: 335.09,
    x2: 59.42,
    y2: 332.81,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: 331.73,
    x2: 64.11,
    y2: 328.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.64,353.41s-3.63-1.85-7.35-3.69",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.17,348.67A51.89,51.89,0,0,1,75.36,339",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.79,375.36a40.54,40.54,0,0,0-8.46-8",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,378.82a45.8,45.8,0,0,1,2.33-7.2c1.4-3.09,1.6-3.49,1.6-3.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.89,400a38.09,38.09,0,0,1,4.67-4.85,25.36,25.36,0,0,0,3-2.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.09,395.56a42.91,42.91,0,0,0-3.91-5.35A37.92,37.92,0,0,0,74.59,386",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,409.33a11,11,0,0,0-1.94-5.46c-1.78-2.36-3.89-5.49-4.74-6.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.54,
    y: 341.12,
    width: 93.91,
    height: 8.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.9,
    y: 349.23,
    width: 85.2,
    height: 68.23,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.86,
    y: 353.68,
    width: 79.17,
    height: 20.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.35,
    y: 362.14,
    width: 7.92,
    height: 3.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.86,
    y: 379.89,
    width: 79.17,
    height: 20.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.35,
    y: 388.35,
    width: 7.92,
    height: 3.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.14,
    y: 285.67,
    width: 39.31,
    height: 38.58,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.34 339.21 389.34 322.8 384.25 322.8 384.25 339.21 376.97 339.21 376.97 341 384.25 341 389.34 341 396.62 341 396.62 339.21 389.34 339.21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.6,
    y1: 287.07,
    x2: 369.6,
    y2: 322.01,
    style: {
      fill: "none",
      stroke: "#5c5c5c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.15,
    y1: 287.07,
    x2: 376.15,
    y2: 322.01,
    style: {
      fill: "none",
      stroke: "#5c5c5c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 386.8,
    y1: 287.07,
    x2: 386.8,
    y2: 322.01,
    style: {
      fill: "none",
      stroke: "#5c5c5c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.35,
    y1: 287.07,
    x2: 399.35,
    y2: 322.01,
    style: {
      fill: "none",
      stroke: "#5c5c5c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.45,
    y: 177.95,
    width: 64.12,
    height: 86.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.59,
    y: 186.19,
    width: 51.84,
    height: 69.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Door--inject-15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.64,
    y: 155.47,
    width: 125.3,
    height: 261.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.03,
    y: 167.85,
    width: 45.56,
    height: 68.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.58,
    y: 177.68,
    width: 32.47,
    height: 48.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.58,
    y1: 177.68,
    x2: 234.03,
    y2: 167.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.04,
    y1: 177.68,
    x2: 279.59,
    y2: 167.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.04,
    y1: 226.38,
    x2: 279.59,
    y2: 236.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.58,
    y1: 226.38,
    x2: 234.03,
    y2: 236.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.79,
    y: 167.85,
    width: 45.56,
    height: 68.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.34,
    y: 177.68,
    width: 32.47,
    height: 48.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.34,
    y1: 177.68,
    x2: 288.79,
    y2: 167.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.8,
    y1: 177.68,
    x2: 334.35,
    y2: 167.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.8,
    y1: 226.38,
    x2: 334.35,
    y2: 236.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.34,
    y1: 226.38,
    x2: 288.79,
    y2: 236.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.03,
    y: 253.82,
    width: 45.56,
    height: 68.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.58,
    y: 263.64,
    width: 32.47,
    height: 48.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.58,
    y1: 263.64,
    x2: 234.03,
    y2: 253.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.04,
    y1: 263.64,
    x2: 279.59,
    y2: 253.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.04,
    y1: 312.34,
    x2: 279.59,
    y2: 322.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.58,
    y1: 312.34,
    x2: 234.03,
    y2: 322.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.79,
    y: 253.82,
    width: 45.56,
    height: 68.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.34,
    y: 263.64,
    width: 32.47,
    height: 48.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.34,
    y1: 263.64,
    x2: 288.79,
    y2: 253.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.8,
    y1: 263.64,
    x2: 334.35,
    y2: 253.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.8,
    y1: 312.34,
    x2: 334.35,
    y2: 322.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.34,
    y1: 312.34,
    x2: 288.79,
    y2: 322.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.03,
    y: 341.1,
    width: 45.56,
    height: 68.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.58,
    y: 350.92,
    width: 32.47,
    height: 48.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.58,
    y1: 350.92,
    x2: 234.03,
    y2: 341.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.04,
    y1: 350.92,
    x2: 279.59,
    y2: 341.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.04,
    y1: 399.62,
    x2: 279.59,
    y2: 409.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240.58,
    y1: 399.62,
    x2: 234.03,
    y2: 409.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.79,
    y: 341.1,
    width: 45.56,
    height: 68.35,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.34,
    y: 350.92,
    width: 32.47,
    height: 48.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.34,
    y1: 350.92,
    x2: 288.79,
    y2: 341.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.8,
    y1: 350.92,
    x2: 334.35,
    y2: 341.1,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 327.8,
    y1: 399.62,
    x2: 334.35,
    y2: 409.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 295.34,
    y1: 399.62,
    x2: 288.79,
    y2: 409.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.6,
    cy: 289.49,
    r: 4.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 465.6,
    y1: 417.46,
    x2: 34.4,
    y2: 417.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.19,307.06H279.84a14.85,14.85,0,0,1,14.85,14.85v95.56a0,0,0,0,1,0,0H161.35a0,0,0,0,1,0,0V321.9A14.85,14.85,0,0,1,176.19,307.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,307.06H271.61a14.85,14.85,0,0,1,14.85,14.85v95.56a0,0,0,0,1,0,0H153.12a0,0,0,0,1,0,0V321.9A14.85,14.85,0,0,1,168,307.06Z",
    style: {
      fill: "#787878",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.72,229.69s-12.64-3.3-11.27-16.22,11.27-17.32,18.7-18.7,18.15-1.37,18.15-1.37-2.2-4.4,6.32-5.23,32.17,7.43,41.52,24.2,7.42,44.54,3.3,53.62-8,27.77-.28,34.09,22.28,13.2,20.08,30.8S271.79,349,272.61,358.37s19.25,16.23,14.58,32.45-32.17,18.7-50.87,8.25-14.3-44.27-20.07-63S188.47,314.38,185.17,299s8-23.1,13.48-36S196.72,229.69,196.72,229.69Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,193.4s-35.35-2.38-48,15.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.91,203.68s21.83,16.59,22.7,41.91-10,34-11.79,45.4,7.43,17.89,7.43,17.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.84,209.35s18.77,17,21.83,40.6,0,26.63,0,26.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.93,355.35s-11.55,17.6-14.3,24.47-2.47,12.37,4.68,14S141.46,387,145,383.12s10.17-15.95,10.17-15.95Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,295.68s-28.6-.27-36,2.2-42.9,57.19-42.9,57.19l24.75,16.23,10.72-11.83s3,15.13,3,20.08-3.58,38-3.58,38h82.49s1.38-30.85,6-39.37,11-20.07,11-20.07l23.37,15.12L301.48,338S264.36,308.61,255,304.48,208,295.68,208,295.68Z",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.55,359.47s1-8.85,2.25-17.1,6.34-18.4,6.34-18.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 263.54,
    y1: 358.1,
    x2: 249.3,
    y2: 349.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.72,357.61S248,356.34,243,354.43",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.07 346.23 220.8 429.13 222.76 428.01 226.41 352.39 172.07 346.23",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.11 346.23 166.19 420.17 220.8 429.13 224.44 352.39 170.11 346.23",
    style: {
      fill: "#575757",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.27 370.31 201.48 371.71 199.52 418.21 179.35 414.85 190.27 370.31",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,295.68s-7.34-.07-15.54.18a130.38,130.38,0,0,0-.69,24.29c1.1,13.2,3.85,15.13,11.28,12.93s22.54-20.9,26.94-27.5a46,46,0,0,0,3.55-6.13C220.94,297.29,208,295.68,208,295.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.82,281.66s-1.47,34.1-1.2,38.5,6.43,9.07,10.83,5.77,17.63-23.13,19-26.71,3-19.76,3-19.76-11.82,7.15-19.79,6.32S197.82,281.66,197.82,281.66Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,373.5c-4.12,5.22-8.52,11.82-7.15,16.77s8,7.15,22.55,6.87,55,.83,55.82,1.1,29.69,3,30.79,3,7.15-2.48,8.8-4.68,3-10.72,3-10.72,4.12-4.12,4.4-7.42a6.21,6.21,0,0,0-2.48-5.23,22,22,0,0,0-.82-5.22c-.83-3-6.88-1.65-10.18-2.2s-8.24-1.65-10.17.27-17.87,15.68-17.87,15.68-24.75-1.93-40.42-7.7-24.47-6.88-30.8-.83",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 239.34,
    y1: 373.22,
    x2: 224.77,
    y2: 369.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.62,234.8s-8-4.66-9.32,0S186.62,234.8,186.62,234.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.62,238.8s-7,5.32-3,5.66S185.62,238.8,185.62,238.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.62,212.45s-33.76,11.09-34.24,14-9.64,25.08-7.71,40.51,13.84,21.79,24.45,22.69c12.92,1.1,26.67-16.22,26.67-16.22s7.14-2.75,11-4.67,4.34-7.24,4.34-7.24-9.56-7.1-17.76-21.08A50.43,50.43,0,0,1,229.62,212.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.74,232.7a16.64,16.64,0,0,1-2.41,9.64,13,13,0,0,1-7.23,5.31s.48,5.3,4.34,5.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.1,239s3.85-3.85,9.35.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.183922954575337px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.37,243.44s7.7-.83,9.62,4.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.183922954575337px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.65,259.66s-6.05-2.2-11,1.1-6.05,8.53-3.3,10.18,7.42-5.23,10.72-1.1,8.8,10.72,11,4.39S214.05,260.76,209.65,259.66Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.8,270.74c3.33,4.09,8.23,9.37,10.27,3.49a8.85,8.85,0,0,0,.42-1.87C214.06,272,210.34,271.43,206.8,270.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6,263.21a10,10,0,0,0-4.95-3.55s-5.55-2-10.37.73A101.52,101.52,0,0,0,214.6,263.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.89,267.74a3.31,3.31,0,0,0,1.46,3.2c1.4.83,3.29-.53,5.25-1.53C197.87,268.78,195.52,268.17,193.89,267.74Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59,230.21s-.31-1.89-4.39-1.89-10.68,5-10.68,5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.71,232.09s3.14-3.14,6.28.63a36,36,0,0,1,5,8.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.62,247.56c-21.11-13.3-10-35.11-10-35.11s-21,18-34.24,14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.67,261.86s-3,3.58-3,5.5,6.05,9.9,8.53,6.6-.83-5.77-1.93-9.07S234.67,261.86,234.67,261.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.54,260.76s-19-9.07-25.3-12.37-9.62-.83-9.62-.83-11.28,9.63-10.73,11.28,6.88,6.87,6.88,6.87,3.85,5.5,8.52,6.88,11.55,3.29,12.93,1.09,0-5.49,0-5.49,3.84,3.3,6.32,3.85,7.7,0,7.7,0,10.45,67.36,10.45,77.53,4.4,20.9,12.1,23.38,16.49-3.3,18.14-11.55.83-17.32-4.12-27.5S284.44,277,280.86,270.39,276.74,262.41,274.54,260.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.77,273.41s3.57-9.62,4.95-11.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.72,270.39S245.39,258,247,255.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.77,265.71s3.57-9.62,5.5-12.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.0919614772876685px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Heart--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.81,185.33l-9.56-3.19,7.44-21.24h-9l3.43-13.71a23.89,23.89,0,0,0-40.5,25.26c8.19,17.23,30.37,35.83,39,42.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.75,136.78a23.81,23.81,0,0,0-16.36,6.5l-3.83,12.31,10.63-.53L135.1,179l10.62,2.65L136,215.56c8.14-6.4,31.14-25.47,39.52-43.11a23.9,23.9,0,0,0-20.79-35.67Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartbrokenBro);
export default __webpack_public_path__ + "static/media/Heartbroken-bro.e62f3119cab53ef7b451decaf994d415.svg";
export { ForwardRef as ReactComponent };